import { render, staticRenderFns } from "./HsabExpensePayFromDisplay.vue?vue&type=template&id=4812f8c2&scoped=true"
import script from "./HsabExpensePayFromDisplay.vue?vue&type=script&lang=ts"
export * from "./HsabExpensePayFromDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4812f8c2",
  null
  
)

export default component.exports